import React, { useState } from 'react';
import classnames from 'classnames';
import { useController } from 'react-hook-form';

import { useStore } from '../../store';

import type { Tag } from '../../types/tag';

import '@awesome.me/webawesome/dist/components/tag/tag.js';

interface MemoryTagsProps {
  tags: number[];
  inTimeline?: boolean;
  control: any;
};

const Checkboxes = ({ options, control, name, availableTags }: { options: any[]; control: any; name: string; availableTags: Tag[] }) => {
  const { field } = useController({
    control,
    name
  });
  const [value, setValue] = useState(field.value || []);

  return (
    <>
      {options.map((option, index) => (
        <label key={`tag-${availableTags[index].id}`}>
          <input
            onChange={(e) => {
              const valueCopy = [...value];
              valueCopy[index] = e.target.checked ? parseInt(e.target.value) : null;
              field.onChange(valueCopy);
              setValue(valueCopy);
            }}
            key={option}
            type="checkbox"
            checked={value.includes(option)}
            value={option}
          />
          <wa-tag
            key={`tag-${availableTags[index].id}`}
            size="xs"
            pill
            className={classnames('memory-tag', { 'memory-tag--selected': value.includes(option) })}
          >
            {availableTags[index].name}
          </wa-tag>
        </label>
      ))}
    </>
  );
};

const MemoryTags: React.FC<MemoryTagsProps> = ({ control, inTimeline = false }) => {
  const { tags: availableTags } = useStore((state) => state.settings || { tags: [] });

  const number = inTimeline ? 3 : 4

  return (
    <div className="memory-tags-container inner">
      <div className="memory-tags-header">
        <div className="page-eyebrow">
          <wa-avatar initials={number.toString()} />
          Tag this memory
        </div>
      </div>
      <div className="memory-tags wa-cluster wa-gap-xs">
        <Checkboxes
          options={availableTags.map(tag => tag.id)}
          control={control}
          name="tags"
          availableTags={availableTags}
        />
      </div>
    </div>
  );
}

export default MemoryTags;
